(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["promo-code-100"] && !Shopify.designMode) return;
  try {
    (() => {
    const pendingStorageKey = 'promo-code-100-pending';
    const drawerStorageKey = 'promo-code-100-open-drawer';
    const requestedCodeStorageKey = 'promo-code-100-requested-code';

    class PromoCode100 extends HTMLElement {
      connectedCallback() {
        this.mount();
        this.observer = new MutationObserver(() => this.scheduleMount());
        this.observer.observe(document.body, { childList: true, subtree: true });
        document.addEventListener('click', this.onClick, true);
        document.addEventListener('submit', this.onSubmit, true);
        document.addEventListener('input', this.onInput, true);

        const promotionUrl = new URL(window.location.href);
        const storedRequestedCode = this.takeRequestedCode();
        const requestedCode = promotionUrl.searchParams.get('promo_code') || storedRequestedCode;
        const shouldOpenDrawer = promotionUrl.searchParams.get('open_cart_drawer') === '1' ||
          this.shouldReopenCartDrawer();
        if (shouldOpenDrawer) setTimeout(() => this.openCartDrawer(), 500);
        if (requestedCode === this.dataset.code || this.hasPendingPromotion()) {
          requestAnimationFrame(() => this.resumePromotion(requestedCode === this.dataset.code));
        } else if (requestedCode) {
          requestAnimationFrame(() => this.resumeStandardCode(requestedCode));
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('click', this.onClick, true);
        document.removeEventListener('submit', this.onSubmit, true);
        document.removeEventListener('input', this.onInput, true);
        cancelAnimationFrame(this.mountFrame);
      }

      onClick = (event) => {
        const summary = event.target.closest?.('[data-promo-code-100-drawer] > summary');
        if (summary) this.couponOpen = !summary.parentElement.open;
        const button = event.target.closest?.('[data-promo-code-100-remove]');
        if (!button) return;
        event.preventDefault();
        this.removeCode(button.dataset.discountCode, button);
      };

      onInput = (event) => {
        if (!event.target.matches?.('[data-promo-code-100-form] input[name="discount"]')) return;
        this.attemptedCode = event.target.value;
        this.couponOpen = true;
      };

      onSubmit = (event) => {
        const form = event.target.closest?.('[data-promo-code-100-form]');
        if (!form) return;
        event.preventDefault();
        this.apply(form, form.elements.discount);
      };

      scheduleMount() {
        cancelAnimationFrame(this.mountFrame);
        this.mountFrame = requestAnimationFrame(() => this.mount());
      }

      mount() {
        const template = document.getElementById('PromoCode100Template');
        if (!template) return;

        const targets = [
          document.querySelector('#CartDrawer .drawer__footer'),
          document.querySelector('#main-cart-footer .cart__blocks'),
          document.querySelector('#main-cart-footer .cart__footer'),
        ].filter(Boolean);

        let mounted = false;
        [...new Set(targets)].forEach((target) => {
          if (target.querySelector('[data-promo-code-100-form]')) return;
          target.prepend(template.content.cloneNode(true));
          mounted = true;
        });

        if (mounted) {
          document.querySelectorAll('[data-promo-code-100-form]').forEach((form) => {
              if (this.attemptedCode !== undefined && form.elements.discount) form.elements.discount.value = this.attemptedCode;
              if (this.couponOpen) form.closest('[data-promo-code-100-drawer]').open = true;
              if (this.statusMessage !== undefined) this.setStatus(form, this.statusMessage);
              this.setBusy(form, Boolean(this.statusBusy));
            });
          this.refreshDiscountApplications();
        }
      }

      async refreshDiscountApplications(cart) {
        if (cart) {
          this.updateApplicationDisplays(cart);
          return;
        }
        if (this.discountRefreshPromise) return this.discountRefreshPromise;

        this.discountRefreshPromise = this.fetchCart()
          .then((freshCart) => this.updateApplicationDisplays(freshCart))
          .catch(() => undefined)
          .finally(() => {
            this.discountRefreshPromise = null;
          });

        return this.discountRefreshPromise;
      }

      getDiscountApplications(cart) {
        const applications = [...(cart?.cart_level_discount_applications || [])];
        for (const item of cart?.items || []) {
          for (const allocation of item.line_level_discount_allocations || []) {
            const application = allocation.discount_application;
            if (application) applications.push({ ...application, total_allocated_amount: allocation.amount });
          }
        }
        const codes = new Map();
        for (const application of applications) {
          const type = String(application.type || '').toLowerCase();
          const code = String(application.code || application.title || '').trim().toUpperCase();
          if ((type === 'discount_code' || type === 'discountcode') && code) {
            const previous = codes.get(code);
            codes.set(code, { ...application, total_allocated_amount: Number(previous?.total_allocated_amount || 0) + Number(application.total_allocated_amount || 0) });
          }
        }
        // Recent Ajax responses also expose applicable codes without line allocations (e.g. shipping).
        for (const entry of cart?.discount_codes || []) {
          const key = String(entry.code || '').trim().toUpperCase();
          if (key && entry.applicable === true && !codes.has(key)) codes.set(key, { type: 'discount_code', title: entry.code, total_allocated_amount: 0 });
        }
        return [...codes.values()];
      }

      updateApplicationDisplays(cart) {
        const applications = this.getDiscountApplications(cart);

        document.querySelectorAll('[data-promo-code-100-container]').forEach((container) => {
          const active = container.querySelector('[data-promo-code-100-active]');
          const list = container.querySelector('[data-promo-code-100-active-list]');
          const summary = container.querySelector('[data-promo-code-100-active-count]');
          if (!active || !list || !summary) return;

          list.replaceChildren();
          applications.forEach((application) => {
            const code = String(application.code || application.title || '').trim();
            if (!code) return;

            const item = document.createElement('li');
            item.className = 'promo-code-100__active-item';

            const codeBadge = document.createElement('span');
            codeBadge.className = 'promo-code-100__active-code';
            codeBadge.textContent = code;

            const benefit = document.createElement('span');
            benefit.className = 'promo-code-100__active-benefit';
            const allocated = Number(application.total_allocated_amount || 0);
            benefit.textContent = allocated > 0
              ? String(this.dataset.savingTemplate || '[amount]').replace('[amount]', this.formatMoney(allocated, cart?.currency))
              : this.dataset.successMessage;

            const removeButton = document.createElement('button');
            const removeLabel = String(this.dataset.removeLabelTemplate || '[code]').replace('[code]', code);
            removeButton.className = 'promo-code-100__remove';
            removeButton.type = 'button';
            removeButton.setAttribute('data-promo-code-100-remove', '');
            removeButton.dataset.discountCode = code;
            removeButton.setAttribute('aria-label', removeLabel);
            removeButton.title = removeLabel;
            removeButton.textContent = '×';

            item.append(codeBadge, benefit, removeButton);
            list.append(item);
          });

          const visibleApplications = [...list.children];
          active.hidden = visibleApplications.length === 0;
          summary.hidden = visibleApplications.length === 0;
          if (visibleApplications.length) {
            const firstCode = visibleApplications[0].querySelector('.promo-code-100__active-code')?.textContent || '';
            summary.textContent = visibleApplications.length > 1
              ? `${firstCode} +${visibleApplications.length - 1}`
              : firstCode;
          } else {
            summary.textContent = '';
          }
        });
      }

      async removeCode(requestedCode, trigger) {
        const code = String(requestedCode || '').trim();
        if (!code || this.removingCode) return;

        const keepDrawerOpen = Boolean(trigger?.closest('[data-promo-code-100-drawer]')?.open);
        this.removingCode = true;
        this.setRemoveBusy(true);
        this.setAllStatusText(this.dataset.removingMessage || '');

        try {
          const cart = await this.fetchCart();
          const applications = this.getDiscountApplications(cart);
          const normalizedCode = code.toUpperCase();
          const remainingCodes = applications
            .map((application) => String(application.code || application.title || '').trim())
            .filter((activeCode) => activeCode && activeCode.toUpperCase() !== normalizedCode);

          const body = {
            discount: remainingCodes.join(','),
            sections: this.getSectionIds(),
            sections_url: window.location.pathname,
          };

          if (normalizedCode === String(this.dataset.code).toUpperCase()) {
            const managedGifts = this.findManagedGifts(cart);
            if (managedGifts.length) {
              body.updates = Object.fromEntries(managedGifts.map((gift) => [gift.key, 0]));
            }
            this.clearPendingPromotion();
          }

          const response = await fetch(this.dataset.cartUpdateUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(body),
          });
          const updatedCart = await response.json();
          if (!response.ok || updatedCart.errors || updatedCart.status) throw new Error();

          this.renderCartUpdate(updatedCart);
          await new Promise((resolve) => requestAnimationFrame(resolve));
          this.mount();
          this.updateApplicationDisplays(updatedCart);
          if (keepDrawerOpen) {
            document.querySelectorAll('[data-promo-code-100-drawer]').forEach((drawer) => {
              drawer.open = true;
            });
          }
          this.setAllStatusText(this.dataset.removedMessage || '');
        } catch (_error) {
          this.setAllStatusText(this.dataset.removeErrorMessage || this.dataset.errorMessage || '');
        } finally {
          this.removingCode = false;
          this.setRemoveBusy(false);
        }
      }

      setRemoveBusy(busy) {
        document.querySelectorAll('[data-promo-code-100-remove]').forEach((button) => {
          button.disabled = busy;
          button.toggleAttribute('aria-busy', busy);
        });
      }

      setAllStatusText(message) {
        this.statusMessage = message || '';
        document.querySelectorAll('[data-promo-code-100-form]').forEach((form) => {
          this.setStatus(form, message);
        });
      }

      getSectionIds() {
        const sectionIds = ['cart-drawer'];
        const mainItemsId = document.getElementById('main-cart-items')?.dataset.id;
        const mainFooterId = document.getElementById('main-cart-footer')?.dataset.id;
        if (mainItemsId) sectionIds.push(mainItemsId);
        if (mainFooterId) sectionIds.push(mainFooterId);
        return [...new Set(sectionIds)];
      }

      renderCartUpdate(cart) {
        const cartExtras = document.querySelector('pt-cart-extras');
        if (typeof cartExtras?.renderSections === 'function') {
          cartExtras.renderSections(cart.sections || {}, cart);
          cartExtras.scheduleReconcile?.(0);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'promo-code-100', cartData: cart });
        }
      }

      formatMoney(cents, currency = 'EUR') {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'pt-PT', {
            style: 'currency',
            currency: currency || 'EUR',
          }).format(Number(cents || 0) / 100);
        } catch (_error) {
          return `${(Number(cents || 0) / 100).toFixed(2)} €`;
        }
      }

      setStatus(form, message) {
        this.statusMessage = message || '';
        const status = form.querySelector('[data-promo-code-100-status]');
        if (status && status.textContent !== this.statusMessage) status.textContent = this.statusMessage;
        const drawer = form.closest('[data-promo-code-100-drawer]');
        if (drawer && this.statusMessage && !drawer.open) drawer.open = true;
        const input = form.elements.discount;
        if (input) {
          const invalid = this.statusMessage === this.dataset.invalidMessage || this.statusMessage === this.dataset.ineligibleMessage;
          input.setAttribute('aria-invalid', String(invalid));
          if (status) { status.id ||= 'PromoStatus-' + [...document.querySelectorAll('[data-promo-code-100-form]')].indexOf(form); input.setAttribute('aria-describedby', status.id); }
        }
      }

      setBusy(form, busy) {
        this.statusBusy = busy;
        form.querySelectorAll('input, button').forEach((element) => {
          element.disabled = busy;
          element.toggleAttribute('aria-busy', busy);
        });
      }

      setAllStatuses(message) {
        this.statusMessage = message || '';
        this.statusBusy = true;
        document.querySelectorAll('[data-promo-code-100-form]').forEach((form) => {
          this.setStatus(form, message);
          this.setBusy(form, true);
        });
      }

      setAllBusy(busy) {
        this.statusBusy = busy;
        document.querySelectorAll('[data-promo-code-100-form]').forEach((form) => {
          this.setBusy(form, busy);
        });
      }

      async updateDiscountCodes(codes) {
        const response = await fetch(this.dataset.cartUpdateUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(','), sections: this.getSectionIds(), sections_url: window.location.pathname }),
        });
        const cart = await response.json();
        if (!response.ok || cart.status) throw new Error();
        return cart;
      }

      async apply(form, input) {
        if (this.applying) return;
        const code = String(input?.value || '').trim();
        this.attemptedCode = code;
        if (!code) { this.setStatus(form, this.dataset.invalidMessage); input?.focus(); return; }
        this.applying = true;
        this.setAllStatuses(this.dataset.applyingMessage);
        try {
          const before = await this.fetchCart();
          const previousCodes = this.getDiscountApplications(before).map((app) => String(app.code || app.title));
          const codes = [...new Set([...previousCodes.map((value) => value.toUpperCase()), code.toUpperCase()])];
          let cart = await this.updateDiscountCodes(codes);
          const accepted = this.getDiscountApplications(cart).some((app) => String(app.code || app.title).toUpperCase() === code.toUpperCase());
          if (!accepted) cart = await this.updateDiscountCodes(previousCodes);
          this.renderCartUpdate(cart);
          this.mount();
          await this.refreshDiscountApplications(cart);
          this.setAllStatuses(accepted ? this.dataset.successMessage : this.dataset.invalidMessage);
        } catch (_error) {
          this.setAllStatuses(this.dataset.errorMessage);
        } finally {
          this.clearPendingPromotion(); this.clearDrawerReopenRequest();
          this.applying = false; this.setAllBusy(false);
        }
      }

      async resumeStandardCode(requestedCode) {
        try {
          this.setAllStatuses(this.dataset.applyingMessage);
          const cart = await this.fetchCart();
          const applied = (cart.cart_level_discount_applications || []).some((discount) => {
            const type = String(discount.type || '').toLowerCase();
            const code = String(discount.code || discount.title || '').trim().toUpperCase();
            return (type === 'discount_code' || type === 'discountcode') &&
              code === String(requestedCode).trim().toUpperCase();
          });

          this.cleanPromotionUrl();
          this.setAllStatuses(applied ? this.dataset.successMessage : this.dataset.invalidMessage);
          this.setAllBusy(false);
          await this.refreshDiscountApplications(cart);
          await this.openCartDrawer();
        } catch (_error) {
          this.setAllStatuses(this.dataset.errorMessage);
          this.setAllBusy(false);
          await this.openCartDrawer();
        } finally {
          this.clearDrawerReopenRequest();
        }
      }

      navigateThroughDiscount(code) {
        const currentUrl = new URL(window.location.href);
        const root = window.Shopify?.routes?.root || '/';
        let redirectUrl = new URL(currentUrl.href);
        const cartUrl = new URL(this.dataset.cartUrl, window.location.origin);

        if (redirectUrl.pathname.replace(/\/$/, '') === cartUrl.pathname.replace(/\/$/, '')) {
          redirectUrl = new URL(root, window.location.origin);
        }

        redirectUrl.searchParams.delete('promo_code');
        redirectUrl.searchParams.delete('open_cart_drawer');
        redirectUrl.searchParams.set('promo_code', code);
        redirectUrl.searchParams.set('open_cart_drawer', '1');

        const previewThemeId = currentUrl.searchParams.get('preview_theme_id') || (
          this.dataset.themeId && String(this.dataset.themeRole || '').toLowerCase() !== 'main'
            ? this.dataset.themeId
            : null
        );
        if (previewThemeId) redirectUrl.searchParams.set('preview_theme_id', previewThemeId);

        const redirectTarget = `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`;
        const discountUrl = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectTarget)}`;
        if (String(code).toUpperCase() !== String(this.dataset.code).toUpperCase()) {
          try {
            window.sessionStorage.setItem(requestedCodeStorageKey, code);
          } catch (_error) {}
        }
        window.location.assign(discountUrl);
      }

      async resumePromotion() {
        this.cleanPromotionUrl();
        const form = document.querySelector('[data-promo-code-100-form]');
        if (form) await this.apply(form, { value: this.dataset.code });
        await this.openCartDrawer();
      }

      async fetchCart() {
        const response = await fetch(`${this.dataset.cartUrl}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error();
        return response.json();
      }

      findManagedGifts(cart) {
        return cart.items?.filter((item) =>
          Number(item.variant_id) === Number(this.dataset.giftVariantId) &&
          String(item.properties?.__promo_code_100) === 'true'
        ) || [];
      }

      takeRequestedCode() {
        try {
          const code = window.sessionStorage.getItem(requestedCodeStorageKey);
          window.sessionStorage.removeItem(requestedCodeStorageKey);
          return code;
        } catch (_error) {
          return null;
        }
      }

      markDrawerReopenRequest() {
        try {
          window.sessionStorage.setItem(drawerStorageKey, 'true');
        } catch (_error) {
          return;
        }
      }

      hasPendingPromotion() {
        try {
          return window.sessionStorage.getItem(pendingStorageKey) === this.dataset.code;
        } catch (_error) {
          return false;
        }
      }

      clearPendingPromotion() {
        try {
          window.sessionStorage.removeItem(pendingStorageKey);
        } catch (_error) {
          return;
        }
      }

      shouldReopenCartDrawer() {
        try {
          return window.sessionStorage.getItem(drawerStorageKey) === 'true';
        } catch (_error) {
          return false;
        }
      }

      clearDrawerReopenRequest() {
        try {
          window.sessionStorage.removeItem(drawerStorageKey);
        } catch (_error) {
          return;
        }
      }

      cleanPromotionUrl() {
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('promo_code');
        cleanUrl.searchParams.delete('open_cart_drawer');
        window.history.replaceState({}, '', `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
      }

      async openCartDrawer() {
        await customElements.whenDefined('cart-drawer');

        for (let attempt = 0; attempt < 6; attempt += 1) {
          const drawer = document.querySelector('cart-drawer');
          const trigger = document.querySelector('#cart-icon-bubble, [data-ai-header-cart-link]');
          if (drawer?.classList.contains('active')) return true;

          if (attempt === 0 && typeof drawer?.open === 'function') {
            drawer.open(trigger || undefined);
          } else if (trigger?.getAttribute('role') === 'button') {
            trigger.click();
          } else if (typeof drawer?.open === 'function') {
            drawer.open(trigger || undefined);
          }

          await new Promise((resolve) => setTimeout(resolve, 300));
          if (drawer?.classList.contains('active')) return true;
        }

        return false;
      }
    }

    if (!customElements.get('promo-code-100')) {
      customElements.define('promo-code-100', PromoCode100);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
